(function () {
function $3f2dfe3d275d4551$export$2e2bcd8739ae039() {
    var accordionsCooontainer = document.querySelectorAll("[js-accordion-container]");
    if (!accordionsCooontainer) return;
    accordionsCooontainer.forEach(function(container) {
        var handleClick = function handleClick(e) {
            var target = e.target;
            var title = target.classList.contains(".accordion-title") || target.closest(".accordion-title");
            if (title) {
                var attrParent = title.getAttribute("js-comentario-parent");
                if (attrParent) //parent accordion
                document.querySelectorAll('.accordion-title[js-comentario-parent="'.concat(attrParent, '"]')).forEach(function(i) {
                    if (i !== title) {
                        if (i.closest(".accordion-item").classList.contains("active")) i.click();
                    }
                });
                var idAccordion = title.getAttribute("data-accordion");
                var content = container.querySelector('.accordion-content[data-accordion="'.concat(idAccordion, '"]'));
                var contentDiv = container.querySelector('.accordion-content[data-accordion="'.concat(idAccordion, '"] > div '));
                var pai = content.parentElement.closest(".accordion-content");
                var height = content.scrollHeight;
                title.closest(".accordion-item").classList.toggle("active");
                content.classList.toggle("active");
                var isChildren = content.hasAttribute("js-accordion-child");
                if (isChildren && content.classList.contains("active")) {
                    gsap.set(pai, {
                        height: "auto"
                    });
                    return;
                }
                if (content.classList.contains("active")) gsap.fromTo(content, {
                    height: 0
                }, {
                    height: height,
                    duration: 0.3
                });
                else gsap.fromTo(content, {
                    height: height
                }, {
                    height: 0,
                    duration: 0.3
                });
            }
        };
        container.addEventListener("click", handleClick);
    });
}


function $c0eab5bc5351d202$export$2e2bcd8739ae039() {
    var attr = "[js-breadcrumb]";
    var breadcrumbs = document.querySelectorAll(".breadcrumb".concat(attr));
    breadcrumbs.forEach(function(breadcrumb) {
        var objStr = breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.dataset.obj;
        if (!breadcrumb || !objStr) return;
        var obj = JSON.parse(objStr.replaceAll("'", '"'));
        var aLength = obj.length - 1;
        var items = obj.map(function(param, index) {
            var name = param.name, slug = param.slug, link = param.link;
            return '\n		<li class="'.concat(index === aLength ? "active" : "", '">\n			<a ').concat(link ? 'href="'.concat(link, '"') : "", ' data-slug="').concat(slug, '">').concat(name, "</a>\n		</li>\n		");
        });
        var template = function() {
            return '\n			<ul class="flex flex-wrap breadcrumb-wrapper">\n				<li>\n					<a href="/">\n							Home\n					</a>\n				</li>\n				'.concat(items.join(""), "\n			</ul>\n		");
        };
        breadcrumb.innerHTML = template();
    //  if (GLOBAL.isMobile) {
    // 	const breadMobile = document.querySelector(".breadcrumb-mobile")
    // 	breadMobile.appendChild(breadcrumb)
    //  }
    });
}


function $cb39d5d38d51b974$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $621096155a85468e$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cb39d5d38d51b974$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $3d1ebc11d4258694$export$2e2bcd8739ae039() {
    var tables = document.querySelectorAll("table[js-dataTables]");
    if (!tables.length) return;
    tables.forEach(function(t) {
        var props = t.dataset.props || {};
        var Dtable = $(t).DataTable((0, $621096155a85468e$export$581ff339ea0ba762)({
            "scrollX": true,
            "language": {
                "show": "Visualizar",
                "lengthMenu": "Linhas por p\xe1gina_MENU_ ",
                "zeroRecords": "Nada encontrado",
                "info": "Exibindo p\xe1gina _PAGE_ de _PAGES_",
                "infoEmpty": "Nada encontrado",
                "infoFiltered": "(filtrado de _MAX_ no total)",
                "search": "",
                "paginate": {
                    "previous": "<svg ><use xlink:href='#icon_anterior'></use></svg>",
                    "next": "<svg ><use xlink:href='#icon_proximo'></use></svg>"
                }
            },
            "autoWidth": true,
            "buttons": true,
            "ordering": true,
            "order": [
                [
                    0,
                    "desc"
                ]
            ],
            // rowReorder: {
            //     selector: 'td:nth-child(2)'
            // },
            select: {
                items: "cell"
            },
            ["buttons"]: [
                "excel"
            ],
            responsive: true,
            paginate: true,
            search: false,
            info: false
        }, props));
        GLOBAL.wrap_single(t, "div", [
            "table--container"
        ]);
    // t.querySelectorAll("thead th")
    // 	?.forEach(t => t.addEventListener("click", () => {
    // 		Dtable.columns.adjust().draw();
    // 	}))
    // console.log(Dtable.buttons())
    // Dtable.buttons().container().appendTo('#example_wrapper');
    });
    var input = document.querySelector(".dataTables_filter input");
    var select = document.querySelector(".dataTables_length select");
    var dataFilter = input.closest("div");
    var dataSelect = select.closest(".dataTables_length");
    input.classList.add("input-text", "h-48");
    input.setAttribute("js-ativo", "");
    input.setAttribute("placeholder", "Buscar");
    dataSelect.classList.add("flex", "md2:self-end");
    dataFilter.classList.remove("dataTables_filter");
    dataFilter.classList.add("self-start");
    select.setAttribute("js-choices", "");
    GLOBAL.wrap_single(select, "div", [
        "select-container",
        "h-48",
        "select-left"
    ]);
    GLOBAL.wrap_single(dataFilter, "div", [
        "header-table",
        "md2:flex-col"
    ]);
    document.querySelector(".header-table").appendChild(dataSelect);
}


function $b5545f20455c84b8$export$2e2bcd8739ae039(element, events, callback) {
    var outside = "data-outside";
    var html = document.documentElement;
    if (!element.hasAttribute(outside)) {
        events.forEach(function(userEvent) {
            html.addEventListener(userEvent, handleOutsideClick) //adiciona evento de click que vai aproveitar do bubble
            ;
        });
        element.setAttribute(outside, "") //coloca atributo para nao adicionar o evento mais de uma vez
        ;
    }
    function handleOutsideClick(event) {
        if (!element.contains(event.target)) {
            element.removeAttribute(outside, "");
            events.forEach(function(userEvent) {
                html.removeEventListener(userEvent, handleOutsideClick) //adiciona evento de click que vai aproveitar do bubble
                ;
            });
            callback();
        }
    }
}


function $96c884697ae6a3d3$export$2e2bcd8739ae039() {
    var dropdownMenus = document.querySelectorAll("[js-dropdown]");
    dropdownMenus.forEach(function(menu) {
        [
            "touchstart",
            "click"
        ].forEach(function(userEvent) {
            menu.addEventListener(userEvent, handleClick);
        });
    });
    function handleClick(event) {
        var _this = this;
        // event.preventDefault(); //retirar se tiver click no item
        dropdownMenus.forEach(function(i) {
            return i.classList.remove("active");
        });
        this.classList.add("active");
        // outside click pode ser reaproveitado para outros eventos de bubble
        (0, $b5545f20455c84b8$export$2e2bcd8739ae039)(this, [
            "touchstart",
            "click",
            "mouseleave"
        ], function() {
            _this.classList.remove("active");
        });
    }
}


function $c21f34c1b6eb0b0e$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $b552b62f67cc8a3c$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $c21f34c1b6eb0b0e$export$79e617b1955a2616)(arr);
}


function $24666049daa07ff7$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $f4b76a8ea84892bb$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $89288f2be0c22489$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c21f34c1b6eb0b0e$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c21f34c1b6eb0b0e$export$79e617b1955a2616)(o, minLen);
}


function $53535909f5ee29a1$export$1b5e630bc3aea29f(arr) {
    return (0, $b552b62f67cc8a3c$export$7e0947b5ad3404e2)(arr) || (0, $24666049daa07ff7$export$1eb58a6e75231000)(arr) || (0, $89288f2be0c22489$export$a5be06335b3a083c)(arr) || (0, $f4b76a8ea84892bb$export$e6f3c4780d19eb2b)();
}


function $2046ecdfab271433$export$2e2bcd8739ae039() {
    var hasInlines = document.querySelector("[data-js-inline]");
    if (!hasInlines) return;
    function addRemoveEventInExistingInlines() {
        var btnsRemoveInline = document.querySelectorAll("[class*='remove_inline']");
        btnsRemoveInline.forEach(function(btn) {
            var inline = btn.closest(".inline-item");
            btn.addEventListener("click", function() {
                return removeInline(inline);
            });
        });
    }
    function checkMaxNumAllForms() {
        var maxNumbersElements = document.querySelectorAll("[id$='-MAX_NUM_FORMS']");
        // console.log(maxNumbersElements)
        maxNumbersElements.forEach(function(numberElement) {
            var wrapperInline = numberElement.closest(".wrapper-inline");
            console.log(numberElement.value, numberElement);
            checkMaxNumForm(numberElement.value, wrapperInline);
        });
    }
    function checkMaxNumForm(totalForms, wrapperInline) {
        // console.log(wrapperInline)
        var inlineItens = wrapperInline.querySelectorAll(".inline-item");
        if (inlineItens.length === Number(totalForms)) {
            var dataJsInline = wrapperInline.dataset.jsInline;
            var btnAddInline = document.querySelector(".add_inline[data-js-inline='".concat(dataJsInline, "']"));
            btnAddInline.classList.add("hidden");
        }
    }
    function addAddEventInExistingInlines() {
        var btnsAddInline = document.querySelectorAll(".add_inline");
        btnsAddInline && btnsAddInline.forEach(function(btnAddInline) {
            btnAddInline.addEventListener("click", function() {
                return addInline(btnAddInline.dataset.jsInline);
            });
        });
    }
    function addInline(dataJsInline) {
        var wrapperInline = document.querySelector(".wrapper-inline[data-js-inline='".concat(dataJsInline, "']"));
        var inputMaxForms = wrapperInline.querySelector("[id$='-MAX_NUM_FORMS']");
        var inputFormIndex = wrapperInline.querySelector("[id$='-TOTAL_FORMS']");
        var intFormIndex = parseInt(inputFormIndex.value);
        var emptyForm = $(".empty_inline_form[data-js-inline='".concat(dataJsInline, "']"));
        $(wrapperInline).append(emptyForm.html().replace(/__prefix__/g, intFormIndex));
        var removeBtn = wrapperInline.querySelector(".remove_inline-".concat(intFormIndex));
        var inline = document.querySelector(".inline-".concat(intFormIndex, "[data-js-inline=").concat(dataJsInline, "]"));
        removeBtn.addEventListener("click", function() {
            return removeInline(inline);
        });
        inputFormIndex.value = intFormIndex + 1;
        if (wrapperInline.children) (0, $53535909f5ee29a1$export$1b5e630bc3aea29f)(wrapperInline.children).forEach(function(child) {
            child.setAttribute("new-inline", false);
        });
        extraConfigs(inline);
        checkMaxNumForm(inputMaxForms.value, wrapperInline);
    }
    function removeRequired(listItens) {
        listItens.forEach(function(i) {
            if (i.getAttribute("required")) i.removeAttribute("required");
        });
    }
    function removeInline(inline) {
        var wrapperInline = inline.closest(".wrapper-inline");
        var selects = inline.querySelectorAll("select");
        var inputs = inline.querySelectorAll("input");
        removeRequired(selects);
        removeRequired(inputs);
        var inputMaxForms = wrapperInline.querySelector("[id$='-MAX_NUM_FORMS']");
        var deleteBtn = inline.querySelector("[id$='-DELETE'");
        deleteBtn.setAttribute("checked", true);
        inline.classList.add("hidden");
        checkMaxNumForm(inputMaxForms.value, wrapperInline);
    }
    function extraConfigs(inline) {
        inline.setAttribute("new-inline", true);
        var selects = inline.querySelectorAll("select");
        var props = {
            searchEnabled: true,
            searchChoices: true
        };
        var items = (0, $53535909f5ee29a1$export$1b5e630bc3aea29f)(selects).map(function(select) {
            return GLOBAL.initChoices(select, props);
        });
        //add disabled na primeira opçao do select, caso seja vazio
        addOptionDisabledInChoices(items);
        window.listOfChoices = (0, $53535909f5ee29a1$export$1b5e630bc3aea29f)(listOfChoices).concat((0, $53535909f5ee29a1$export$1b5e630bc3aea29f)(items));
        var wrapperAnexos = inline.querySelector(".wrapper-anexos");
        // remove o desabilitado caso o produto tenha anexos
        selects.forEach(function(select) {
            if (select.getAttribute("js-select-produto")) select.addEventListener("change", function() {
                wrapperAnexos && wrapperAnexos.classList.remove("disabled-container");
            });
        });
    }
    function addOptionDisabledInChoices(lista) {
        var options = lista.map(function(choice) {
            return choice._presetChoices;
        }).map(function(options) {
            return options.map(function(opt) {
                if (opt.value == "") opt.disabled = true;
                return opt;
            });
        });
        lista.map(function(choice) {
            return choice.setChoices(options[0], "value", "label", true);
        });
    }
    (function init() {
        addAddEventInExistingInlines();
        addRemoveEventInExistingInlines();
        checkMaxNumAllForms();
    })();
}


function $205e8b8d8015b418$export$2e2bcd8739ae039() {
    //seta em todos esses tipos de input a classe active
    // se tiver length
    var attr = "[js-ativo]";
    var type = "\n	input[type='text']".concat(attr, ", \n	input[type='number']").concat(attr, ", \n	input[type='email']").concat(attr, ",\n	textarea").concat(attr, "\n	");
    var inputs = document.querySelectorAll(type);
    // console.log('inputs', inputs)
    inputs === null || inputs === void 0 ? void 0 : inputs.forEach(function(input) {
        return handleClass(false)(input);
    });
    inputs === null || inputs === void 0 ? void 0 : inputs.forEach(function(input) {
        return input.addEventListener("change", handleClass(true));
    });
    function handleClass(isEvent) {
        return function(event) {
            var input = isEvent ? event.currentTarget : event;
            input.value.length !== 0 ? input.classList.add("active") : input.classList.remove("active");
        };
    }
}


var $0e81e892d5a52a46$var$isTablet = GLOBAL.isTablet, $0e81e892d5a52a46$var$debounceFunction = GLOBAL.debounceFunction;
function $0e81e892d5a52a46$export$2e2bcd8739ae039(obj) {
    var state = {
        open: false,
        delay: 150
    };
    var sidebar = document.querySelector(".sidebar");
    var body = document.body;
    var svgAdicionar = '<svg><use xlink:href="#icon_add"></use></svg>';
    var svgList = '<svg><use xlink:href="#icon_list"></use></svg>';
    var svgArrow = '<svg class="icon group-hover:opacity-100 icon-arrow"><use xlink:href="#icon_arrow_left"></use></svg>';
    var iconBack = '<svg class="icon-back group-hover:opacity-100 icon-arrow h-32 w-32"><use xlink:href="#icon_back_arrow"></use></svg>';
    var tipyAdicionar = 'data-tippy-content="Adicionar"';
    var tipyList = 'data-tippy-content="Lista"';
    var fundo = document.querySelector(".nav-fundo ");
    var itensLV0 = sidebar.querySelectorAll("[js-menu-lista]  > li[js-lista-name] ");
    var toogle = document.querySelector("[js-menu-toggle]");
    // Titulo
    var templateModuleName = function(name, icon) {
        return "<li class='module-name'>".concat(icon && !$0e81e892d5a52a46$var$isTablet ? icon.outerHTML : "", " ").concat($0e81e892d5a52a46$var$isTablet ? iconBack : "", "  ").concat(name, "<li>");
    };
    // Me de o menu pertencente
    var getStaticMenu = function(slug) {
        return document.querySelector("[js-menu-lista] [js-lista-name='".concat(slug, "']"));
    };
    // Popula os leveis do menu
    var populateMenuLevel = function(itemMenu, submenu, name, svg) {
        var templateSubMenu = templateLevelMenu(submenu);
        var templateItems = submenu.items.map(templateItensSubmenu);
        templateSubMenu.innerHTML = templateItems.join("");
        templateSubMenu.insertAdjacentHTML("afterbegin", templateModuleName(name, svg));
        itemMenu.appendChild(templateSubMenu);
        itemMenu.classList.add("have-submenu");
    };
    // Template das liZ	
    var templateItensSubmenu = function(item) {
        var name = item.name, link = item.link, list = item.list, adicionar = item.adicionar, slug = item.slug, submenu = item.submenu;
        // console.log(item)
        return '\n				<li class="group" js-lista-name=\''.concat(slug, "' ").concat(submenu ? "data-submenu" : "", '>\n					<div class="item-wrapper">\n						<a ').concat(link ? 'href="'.concat(link, '"') : "", " class='item'> ").concat(name, "	</a>\n						").concat(adicionar ? "<a ".concat(tipyAdicionar, " class='adicionar' href=\"").concat(adicionar, '">').concat(svgAdicionar, "</a>") : "", "\n						").concat(list ? "<a ".concat(tipyList, " class='lista' href=\"").concat(list, '">').concat(svgList, "</a>") : "", "\n						").concat(submenu ? svgArrow : "", "\n					</div>\n				</li>");
    };
    // Template dos sublevel
    var templateLevelMenu = function(submenu) {
        var div = document.createElement("ul");
        div.setAttribute("data-level", submenu.level);
        div.classList.add("submenu");
        return div;
    };
    //Cria subMenus
    var createSubMenus = function(param) {
        var slug = param.slug, submenu = param.submenu, name = param.name;
        var itemMenu1 = getStaticMenu(slug);
        var svg = itemMenu1.querySelector("svg").cloneNode(true);
        svg.style.setProperty("--cor-1", "white");
        if (!submenu) return;
        populateMenuLevel(itemMenu1, submenu, name, svg);
        submenu.items.forEach(function(param) {
            var slug = param.slug, submenu = param.submenu, name = param.name;
            var itemMenu2 = getStaticMenu(slug);
            if (!submenu) return;
            populateMenuLevel(itemMenu2, submenu, name);
            submenu.items.forEach(function(param) {
                var slug = param.slug, submenu = param.submenu, name = param.name;
                var itemMenu3 = getStaticMenu(slug);
                if (!submenu) return;
                populateMenuLevel(itemMenu3, submenu, name);
            });
        });
    };
    var handleClickFundo = function() {
        itensLV0.forEach(function(i) {
            return i.classList.remove("active");
        });
        body.classList.remove("menu-ativo");
        toogleMenu();
    };
    var handleClickItem = function(i) {
        return function(e) {
            //e.preventDefault()
            setTimeout(function() {
                return sidebar.classList.add("animou");
            }, 200) //add classe para animar apenas uma vez
            ;
            body.classList.add("menu-ativo") //add classe para mostrar o fundo do menu
            ;
            itensLV0.forEach(function(i) {
                return i.classList.remove("active");
            }) //remove ativo tds outros
            ;
            body.classList.remove("dont-open-submenu") // remove a classe que impede que o submenu seja aberto
            ;
            i.classList.toggle("active");
        };
    };
    var toogleMenu = function() {
        //funcao do jquery que me da mais certeza c o menu esta aberto ou n
        if (!$0e81e892d5a52a46$var$isTablet) {
            if (body.classList.contains("menu-ativo")) return;
            state.open = !$(sidebar).is(":hover");
        }
        // console.log(state.open);
        if (state.open) {
            body.classList.add("menu-closed");
            body.classList.add("dont-open-submenu");
            sidebar.classList.remove("animou");
            if ($0e81e892d5a52a46$var$isTablet) {
                state.open = false;
                body.classList.remove("menu-ativo");
            }
        } else {
            body.classList.remove("menu-closed");
            body.classList.remove("menu-ativo");
            if ($0e81e892d5a52a46$var$isTablet) state.open = true;
        }
    };
    // const showLevelActive = (e) => {
    // 	const level = Number(e.target.closest(".have-submenu")?.querySelector(".submenu").dataset.level) + 1
    // 	console.log(level);
    // 	if (level === 3) sidebar.setAttribute("data-radius", "3")
    // 	if (level === 2) sidebar.setAttribute("data-radius", "2")
    // 	if (level === 1) sidebar.setAttribute("data-radius", "1")
    // }
    var backLevel = function(e) {
        setTimeout(function() {
            return itensLV0.forEach(function(i) {
                return i.classList.remove("active");
            });
        }, 100);
    };
    var events = function() {
        itensLV0.forEach(function(i) {
            return i.addEventListener("click", handleClickItem(i));
        });
        if ($0e81e892d5a52a46$var$isTablet) {
            toogle === null || toogle === void 0 ? void 0 : toogle.addEventListener("click", toogleMenu);
            document.querySelectorAll(".icon-back").forEach(function(i) {
                return i.addEventListener("click", backLevel);
            });
        } else {
            sidebar.addEventListener("mouseenter", $0e81e892d5a52a46$var$debounceFunction(toogleMenu, state.delay));
            sidebar.addEventListener("mouseout", toogleMenu);
            fundo.addEventListener("click", handleClickFundo);
        }
    // sidebar.addEventListener("mousemove", showLevelActive)
    };
    function init() {
        obj.forEach(createSubMenus);
        events();
        return this;
    }
    return {
        init: init,
        toogleMenu: toogleMenu
    };
}


function $22a75a886b0b8dbc$export$2e2bcd8739ae039() {
    var attr = document.querySelector("[data-secao]");
    if (!attr) return;
    var secao = GLOBAL.url.searchParams.get("secao");
    var wrapperSecao = document.querySelector("[data-secao='".concat(secao, "']"));
    wrapperSecao && wrapperSecao.classList.remove("hidden");
}


function $f19d211b09d52e5e$export$2e2bcd8739ae039() {
    var url = GLOBAL.url;
    if (url.searchParams.has("mensagem_toastify")) {
        var mensagemToastify = url.searchParams.get("mensagem_toastify");
        Toastify({
            text: mensagemToastify,
            duration: 3000,
            position: "center",
            stopOnFocus: true
        }).showToast();
        url.searchParams.set("mensagem_toastify", "");
        url.search = "";
        window.history.pushState({}, "", url);
    }
}




function $e09c849cb9644edb$export$2e2bcd8739ae039() {
    var _this;
    var allSelects = (_this = (0, $53535909f5ee29a1$export$1b5e630bc3aea29f)(document.querySelectorAll("select[js-choices]"))) === null || _this === void 0 ? void 0 : _this.filter(function(select) {
        return !select.hasAttribute("js-no-choices");
    });
    if (!allSelects) return;
    var listOfChoices = (0, $53535909f5ee29a1$export$1b5e630bc3aea29f)(allSelects).map(function(i) {
        var hasAttr = i.getAttribute("js-choices-props");
        var props = hasAttr ? JSON.parse(hasAttr) : {};
        return GLOBAL.initChoices(i, (0, $621096155a85468e$export$581ff339ea0ba762)({
            searchEnabled: false,
            searchChoices: false,
            itemSelectText: "Selecionar",
            noResultsText: "Nada Encontrado..."
        }, props));
    });
    window.listOfChoices = listOfChoices;
}


function $8ba429b0b9b3dac4$export$2e2bcd8739ae039() {
    var attr = "[js-tab]";
    var tabs = document.querySelectorAll(".tabs".concat(attr));
    // console.log(tabs);
    if (!tabs.length) return;
    tabs.forEach(function(t) {
        return initTab(t);
    });
    function initTab(tab) {
        // console.log(tab);
        var collapses = tab.querySelectorAll(".tab-collapse");
        var tabItens = tab.querySelectorAll(".tabs-wrapper .tab-item");
        tabItens.forEach(function(t) {
            t.addEventListener("click", function(e) {
                collapses.forEach(function(c) {
                    return c.classList.remove("active");
                });
                tabItens.forEach(function(c) {
                    return c.classList.remove("active");
                });
                t.classList.add("active");
                var att = e.currentTarget.dataset.tab;
                collapses.forEach(function(c) {
                    var attCollapse = c.getAttribute("data-tab");
                    // console.log(attCollapse, att);
                    if (attCollapse == att) c.classList.add("active");
                });
            });
        });
    }
}


function $ae9b8d77b8bd2975$export$2e2bcd8739ae039() {
    var attr = "[js-password]";
    var divs = document.querySelectorAll(".show-password".concat(attr));
    if (!divs.length) return;
    function handleEvent(div) {
        return function(event) {
            var input = div.querySelector("[js-input-password]");
            var item = event.currentTarget;
            input.type = input.type == "text" ? "password" : "text";
            if (input.type == "text") item.classList.add("mostra");
            else item.classList.remove("mostra");
        };
    }
    divs.forEach(function(div) {
        var buttonPass = div.querySelector(".password");
        buttonPass.addEventListener("click", handleEvent(div));
    });
}



function $63778ce2e408aa91$export$2e2bcd8739ae039() {
    var attr = "[js-selecionar-colunas]";
    var els = document.querySelectorAll(attr);
    if (!els.length) return;
    var url = new URL(window.location);
    var filtersOBJ = GLOBAL.splitFilters(url.search);
    var colunasOcultas;
    var colunasInicialmenteOcultas;
    var showHideColun = function(el, drop) {
        return function(e) {
            var value = el.value;
            var table = document.querySelector("table");
            var tableColuns = table.querySelectorAll("[data-reference='".concat(value, "']"));
            if (e.currentTarget.checked === false) tableColuns.forEach(function(i) {
                return i.classList.add("hidden");
            });
            else tableColuns.forEach(function(i) {
                return i.classList.remove("hidden");
            });
            colunasOcultas = (0, $53535909f5ee29a1$export$1b5e630bc3aea29f)(drop.querySelectorAll("input")).filter(function(i) {
                return !i.checked;
            }).map(function(i) {
                return i.value;
            }).join();
            if (filtersOBJ) filtersOBJ["colunas_ocultas"] = colunasOcultas;
            else {
                filtersOBJ = {};
                filtersOBJ["colunas_ocultas"] = colunasOcultas;
            }
            var newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            history.pushState(null, null, "".concat(url.origin).concat(url.pathname).concat(newFilters));
        };
    };
    if (filtersOBJ) {
        if (filtersOBJ["colunas_ocultas"]) colunasInicialmenteOcultas = filtersOBJ["colunas_ocultas"].split(",");
    }
    els.forEach(function(drop) {
        var inputs = drop.querySelectorAll("input");
        inputs.forEach(function(input) {
            return input.addEventListener("change", showHideColun(input, drop));
        });
        if (colunasInicialmenteOcultas) {
            var els = (0, $53535909f5ee29a1$export$1b5e630bc3aea29f)(drop.querySelectorAll(colunasInicialmenteOcultas.map(function(i) {
                return "input[value=".concat(i, "]");
            }).join(",")));
            els === null || els === void 0 ? void 0 : els.forEach(function(i) {
                i.checked = false;
                i.dispatchEvent(new Event("change"));
            });
        }
    });
}


function $317043d73433f2bc$export$2e2bcd8739ae039() {
    var attr = "js-table-ordenation";
    var els = document.querySelectorAll("table[".concat(attr, "]"));
    if (!els.length) return;
    var url = GLOBAL.url;
    var filtersOBJ = GLOBAL.splitFilters(url.search);
    var order = filtersOBJ === null || filtersOBJ === void 0 ? void 0 : filtersOBJ.order;
    if (!order) return;
    var upOrDown = (order === null || order === void 0 ? void 0 : order.includes("-")) ? "down" : "up";
    console.log("FILTROS ATIVOS", filtersOBJ);
    els.forEach(function(table) {
        console.log(order);
        var th = table.querySelector("thead [data-reference='".concat(order.replace("-", ""), "']"));
        console.log("th", th);
        th === null || th === void 0 ? void 0 : th.classList.add(upOrDown);
    });
}


function $6eb1e148e28902f2$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $d731cbd7d86c765e$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $6a2c09daf467e4df$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $316f9f54a2303539$export$fdf2a89c76341bbf(arr, i) {
    return (0, $6eb1e148e28902f2$export$e6256bf45c68d561)(arr) || (0, $d731cbd7d86c765e$export$2fd15edff6687200)(arr, i) || (0, $89288f2be0c22489$export$a5be06335b3a083c)(arr, i) || (0, $6a2c09daf467e4df$export$60dbc22abd7da546)();
}


function $69bc85ee0ce1602d$export$2e2bcd8739ae039() {
    var attr = "js-add-filter";
    var els = document.querySelectorAll("[".concat(attr, "]"));
    // console.log(els);
    if (!els.length) return;
    els.forEach(function(i) {
        return i.addEventListener("click", handleCallback);
    });
    function handleCallback(e) {
        var _target_getAttribute;
        e.preventDefault();
        var target = e.currentTarget;
        var filtro = (_target_getAttribute = target.getAttribute("js-add-filter")) === null || _target_getAttribute === void 0 ? void 0 : _target_getAttribute.split(",");
        var _filtro = (0, $316f9f54a2303539$export$fdf2a89c76341bbf)(filtro, 2), param = _filtro[0], value = _filtro[1];
        var valueClean = value === null || value === void 0 ? void 0 : value.trim();
        var url = new URL(window.location);
        var filtersOBJ = GLOBAL.splitFilters(url.search);
        // const haveSameFilter = filtersOBJ ? filtersOBJ[param] : false
        if (filtersOBJ) {
            var _filtersOBJ_order;
            if (param === "order" && ((_filtersOBJ_order = filtersOBJ.order) === null || _filtersOBJ_order === void 0 ? void 0 : _filtersOBJ_order.replace("-", "")) === valueClean) {
                // console.log(target.classList.contains("up"));
                if (target.classList.contains("up")) filtersOBJ[param] = "-".concat(valueClean);
                else filtersOBJ[param] = valueClean;
            } else filtersOBJ[param] = valueClean;
        } else {
            filtersOBJ = {};
            filtersOBJ[param] = value;
        }
        var newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
        window.location.href = "".concat(url.origin).concat(url.pathname).concat(newFilters);
    }
}


function $587ba43941d5e4e6$export$2e2bcd8739ae039() {
    var attr = "js-table-search";
    var els = document.querySelectorAll("[".concat(attr, "]"));
    var url = new URL(window.location);
    var filtersOBJ = GLOBAL.splitFilters(url.search);
    if (!els.length) return;
    els.forEach(function(i) {
        var wrapper = i.closest(".input-container");
        var btn = wrapper.querySelector("button");
        var btnClear = i.nextElementSibling;
        btnClear.addEventListener("click", function() {
            filtersOBJ = {};
            var newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            window.location.href = "".concat(url.origin).concat(url.pathname).concat(newFilters);
        });
        btn.addEventListener("click", search(i));
        i.addEventListener("keyup", function(e) {
            showBtnClearFilter(i, btnClear);
        });
    // if (!filtersOBJ) return
    // if (filtersOBJ["filter"]) {
    // 	i.value = filtersOBJ["filter"]
    // } else {
    // 	return
    // }
    });
    function search(input) {
        return function(e) {
            var target = e.currentTarget;
            var btnClear = input.nextElementSibling;
            showBtnClearFilter(input, btnClear);
            if (filtersOBJ) filtersOBJ["filter"] = input.value;
            else {
                filtersOBJ = {};
                filtersOBJ["filter"] = input.value;
            }
            var newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            window.location.href = "".concat(url.origin).concat(url.pathname).concat(newFilters);
        };
    }
    function showBtnClearFilter(input, btn) {
        if (input.value != "") btn.classList.remove("hidden");
        else btn.classList.add("hidden");
    }
}


function $235375ae4e32064b$export$2e2bcd8739ae039() {
    var attr = "js-table-qnt";
    var els = document.querySelectorAll("[".concat(attr, "]"));
    var url = new URL(window.location);
    var filtersOBJ = GLOBAL.splitFilters(url.search);
    if (!els.length) return;
    els.forEach(function(i) {
        i.addEventListener("change", search(i));
        if (!filtersOBJ) return;
        if (filtersOBJ["paginate_by"]) {
            var select = GLOBAL.getChoicesActive(i.id, listOfChoices);
            select.setChoiceByValue(filtersOBJ["paginate_by"]);
        }
    });
    function search(input) {
        return function(e) {
            var target = e.currentTarget;
            var url = new URL(window.location);
            var filtersOBJ = GLOBAL.splitFilters(url.search);
            if (filtersOBJ) filtersOBJ["paginate_by"] = target.value;
            else {
                filtersOBJ = {};
                filtersOBJ["paginate_by"] = target.value;
            }
            var newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            window.location.href = "".concat(url.origin).concat(url.pathname).concat(newFilters);
        };
    }
}


function $da1da581d5b7157f$export$2e2bcd8739ae039() {
    var attr = "js-table-recentes";
    var els = document.querySelectorAll("[".concat(attr, "]"));
    var url = new URL(window.location);
    var filtersOBJ = GLOBAL.splitFilters(url.search);
    if (!els.length) return;
    els.forEach(function(i) {
        i.addEventListener("change", search(i));
        if (!filtersOBJ) return;
        if (filtersOBJ["order"]) {
            var select = GLOBAL.getChoicesActive(i.id, listOfChoices);
            select.setChoiceByValue(filtersOBJ["order"]);
        }
    });
    function search(input) {
        return function(e) {
            var url = new URL(window.location);
            var filtersOBJ = GLOBAL.splitFilters(url.search);
            var target = e.currentTarget;
            if (filtersOBJ) filtersOBJ["order"] = target.value;
            else {
                filtersOBJ = {};
                filtersOBJ["order"] = target.value;
            }
            var newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            window.location.href = "".concat(url.origin).concat(url.pathname).concat(newFilters);
        };
    }
}


function $18bd69296407b2f6$export$2e2bcd8739ae039() {
    var attr = "[js-badge]";
    var badges = document.querySelectorAll(".badge".concat(attr));
    if (!badges.length) return;
    badges.forEach(function(badge) {
        var color = getComputedStyle(badge).getPropertyValue("--color");
        if (!color) return;
        badge.style.color = color;
        badge.style.background = GLOBAL.addAlpha(color, 0.1);
    });
}


function $c897b5d91a827bfa$export$2e2bcd8739ae039() {
    var numeroAnexos = 0;
    function FilepondCardsCreator(obj) {
        var containerCards = obj.containerCards, tabsSeletor = obj.tabsSeletor, haveTabs = obj.haveTabs, contentClass = obj.contentClass, tipoProduto = obj.tipoProduto;
        var content = document.querySelector(contentClass);
        var produtoContainer = tipoProduto ? content.closest(".modalX") : null;
        var modaldata = function() {
            return tipoProduto ? produtoContainer.getAttribute("data-modaldata") : null;
        };
        var containerProduto = tipoProduto ? getContainerProduto() : null;
        var container = containerProduto || document.querySelector(containerCards);
        var inputs = content.querySelectorAll("input");
        console.log(inputs);
        var setNameInInput = function(input, name) {
            return input.name = name;
        };
        function getContainerProduto() {
            var _$obj = JSON.parse(modaldata());
            var container = document.querySelector("#".concat(_$obj.inputSeletor));
            return container.closest(".inline-item").querySelector(".wrapper-anexos");
        }
        function createCards() {
            inputs.forEach(function(input) {
                if (haveTabs) {
                    var parent = input.closest(".tab-collapse");
                    var categoriaName = parent.getAttribute("data-name");
                    var categoriaID = parent.getAttribute("data-idcategoria");
                    console.log(categoriaName, "name");
                    var selectParent = parent.closest("select");
                    var arrayFiles = Object.values(input.files);
                    var select = tipoProduto ? getContainerProduto().closest(".inline-item").querySelector("select") : null;
                    var template = arrayFiles.map(function(file) {
                        return geraTemplateAnexo({
                            name: file.name,
                            categoriaName: categoriaName
                        });
                    }).map(function(div) {
                        var clone = input.cloneNode(true);
                        clone.classList.add("invisible");
                        if (tipoProduto) {
                            var produtoID = GLOBAL.getChoicesActive(select.id, listOfChoices).getValue().value;
                            setNameInInput(clone, "categoria_item-".concat(categoriaID, "-").concat(produtoID, "-").concat(numeroAnexos));
                        } else setNameInInput(clone, "categoria-".concat(categoriaID, "-").concat(numeroAnexos));
                        div.appendChild(clone);
                        numeroAnexos++;
                        return div;
                    });
                    template.map(function(i) {
                        return tipoProduto ? getContainerProduto().appendChild(i) : container.appendChild(i);
                    });
                } else {
                    var arrayFiles1 = Object.values(input.files);
                    var template1 = arrayFiles1.map(function(file) {
                        return geraTemplateAnexo({
                            name: file.name
                        });
                    }).map(function(div) {
                        var clone = input.cloneNode(true);
                        console.log("clone", clone);
                        div.appendChild(clone);
                        return div;
                    });
                    if (tipoProduto) {
                        template1.map(function(i) {
                            return getContainerProduto().appendChild(i);
                        });
                        return;
                    }
                    template1.map(function(i) {
                        return container.appendChild(i);
                    });
                }
            });
            //removendo os items do filepond depois de popular 
            filepondList.forEach(function(f) {
                return f.removeFiles();
            });
        }
        function geraTemplateAnexo(param) {
            var name = param.name, categoriaName = param.categoriaName;
            var div = document.createElement("div");
            div.classList.add("container-anexo-item", "w-full");
            div.innerHTML = '\n				<div\n					class="anexo-item  flex flex-col bg-white min-w-[16.25rem] w-full h-[7.25rem] border-[.0938rem] border-neutral-30 shadow-xs rounded relative shrink-0">\n					<div class="w-full m-0 h-40 bg-primary-10 rounded-t flex justify-end items-center">\n						<div  onclick="this.closest(\'.container-anexo-item\').remove()"  class="close !w-24 !h-24 rounded-full bg-alert-red-10 shrink-0  cursor-pointer transition-transform hover:scale-110 grid place-items-center mr-8">\n							<svg class="text-alert-red-100 !w-12 !h-12">\n								<use xlink:href="#icon_close"></use>\n							</svg>\n						</div>\n					</div>\n					<svg class="w-32 h-32 absolute top-24 left-8">\n						<use xlink:href="#icon_file"></use>\n					</svg>\n					<div class="flex flex-col mx-14 mt-24">\n						<h1 class="text-neutral-80 text-sm font-semibold">'.concat(categoriaName, '</h1>\n						<p class="text-neutral-70 text-xs font-medium max-2-lines">').concat(name, "</p>\n					</div>\n					\n					\n				</div>\n			");
            return div;
        }
        return {
            createCards: createCards
        };
    }
    window.FilepondCardsCreator = FilepondCardsCreator;
}


function $7c1d9eb929b0fae3$export$2e2bcd8739ae039() {
    var forms = document.querySelectorAll("[js-mutation-observer]");
    forms.forEach(function(form) {
        var requiredData = //alterando atributo de required para data-required
        function requiredData() {
            console.log(selects, " selects");
            selects.forEach(function(select) {
                if (select.required) {
                    select.setAttribute("data-required", true);
                    select.removeAttribute("required");
                }
            });
        };
        var callbackMutation = //callback do observer
        function callbackMutation(mutations) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var mutation = _step.value;
                    if (mutation.type === "childList") console.log(mutation, "mutation");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        var isInvalidSelect = //verfifica se existe select com o attr data-required vazio
        function isInvalidSelect() {
            var isVazio = false;
            selects.forEach(function(select) {
                if (select.getAttribute("data-required") && select.value == "") isVazio = true;
            });
            return isVazio;
        };
        var submit = function submit() {
            form.addEventListener("submit", function(e) {
                if (isInvalidSelect()) {
                    e.preventDefault();
                    GLOBAL.showToastify("Preencha todos os campos para seguir");
                }
                observer.disconnect();
            });
        };
        var init = function init() {
            requiredData();
            submit();
        };
        var selects = form.querySelectorAll("select");
        var observer = new MutationObserver(callbackMutation);
        console.log(form);
        //Observando mudança nos filhos do form
        observer.observe(form, {
            childList: true
        });
        //identifica mudanças no form pra alterar attr de possíveis novos selects
        form.addEventListener("change", function() {
            requiredData();
        });
        init();
    });
}


function $58e8d06c77f72924$export$2e2bcd8739ae039() {
    var menu = document.querySelector(".menu-header");
    var obody = document.body;
    var navegacao = document.querySelector(".navegacao");
    var btnMobile = document.querySelector("#btn-mobile");
    if (navegacao) navegacao.addEventListener("click", function(e) {
        if (e.target.classList.contains("arrow-down")) {
            e.preventDefault();
            var subMenu = e.target.closest(".menu-item-has-children").querySelector(".sub-menu");
            subMenu.classList.toggle("active-sub-menu");
            subMenu.closest(".menu-item-has-children").classList.toggle("active");
            subMenu.querySelectorAll("li a").forEach(function(item) {
                if (e.target !== item) return;
                navegacao.classList.remove("active");
                menu.classList.remove("bg-on-menu-open");
            });
        }
    });
    var toggleMenu = function(event) {
        if (event.type === "touchstart") event.preventDefault();
        navegacao.classList.toggle("active");
        menu.classList.toggle("bg-on-menu-open");
        var active = navegacao.classList.contains("active");
        event.currentTarget.setAttribute("aria-expanded", active);
        if (active) {
            event.currentTarget.setAttribute("aria-label", "Fechar menu");
            obody.classList.add("menuIsOpen");
            menu.classList.remove("sticky");
        } else {
            obody.classList.remove("menuIsOpen");
            event.currentTarget.setAttribute("aria-label", "Abrir menu");
        }
    };
    btnMobile && btnMobile.addEventListener("click", toggleMenu);
    menu && window.addEventListener("scroll", function() {
        menu.classList.toggle("sticky", window.scrollY > 150);
    });
}


function $1d38e042de70a016$export$2e2bcd8739ae039() {
    var elements = document.querySelectorAll("[submit-onchange]");
    elements.forEach(function(element) {
        return element.addEventListener("change", function(event) {
            return submitElement(element);
        });
    });
    function submitElement(element) {
        var form = element.closest("form");
        form.submit();
    }
}


function $5a19cc8bf822ea54$export$2e2bcd8739ae039() {
    var inputs = document.querySelectorAll("[js-focus]");
    if (!inputs) return;
    inputs.forEach(function(input) {
        input.addEventListener("focus", function(event) {
            return toggleClass(input);
        });
        input.addEventListener("focusout", function(event) {
            return toggleClass(input);
        });
    });
    function toggleClass(element) {
        var target = element.getAttribute("margin-target");
        var targetElement = document.querySelector(target);
        var value = element.value;
        var isActive = document.activeElement == element;
        if (value || isActive) targetElement.classList.remove("-mt-24");
        else targetElement.classList.add("-mt-24");
    }
}


function $c99f99fca54a91b4$export$2e2bcd8739ae039() {
    var inputs = document.querySelectorAll("[data-mask]");
    if (!inputs) return;
    inputs.forEach(function(input) {
        return applyMask(input);
    });
    function applyMask(input) {
        var mask = input.dataset.mask;
        $(input).mask(mask);
    }
}


function $100c9146e4611213$export$2e2bcd8739ae039() {
    var linkOndeAportar = document.querySelector("[js-modal-menu]");
    var linkDefinirObjetivo = document.querySelector("[js-conditional-link]");
    var modal_menu = ModalX(".modal_menu", {
        deep: true,
        zIndex: 1000000,
        zIndexDeep: 900000
    });
    function redirectToURL(evt, route) {
        evt.preventDefault();
        window.location.href = "".concat(window.location.origin, "/").concat(route);
    }
    function conditionalLinks() {
        if (!GLOBAL.checkIfExistsValueOnLocalStorage("estadoAtual")) {
            console.log("entrou");
            linkOndeAportar && linkOndeAportar.addEventListener("click", function(e) {
                return redirectToURL(e, "adicionar-manualmente");
            });
            linkDefinirObjetivo && linkDefinirObjetivo.addEventListener("click", function(e) {
                return redirectToURL(e, "definicao-objetivo");
            });
        } else {
            linkDefinirObjetivo && linkDefinirObjetivo.addEventListener("click", function(e) {
                return redirectToURL(e, "adicionar-objetivo");
            });
            modal_menu.init();
        }
    }
// window.addEventListener("click", ({target}) => {
//   if (!target.hasAttribute("js-modal-menu") || !target.hasAttribute("js-conditional-link")) 
//     return;
//   conditionalLinks();
// });
// conditionalLinks();
}


function $a1727a7253abe12d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $a1727a7253abe12d$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $a1727a7253abe12d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $a1727a7253abe12d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



function $62bbba4b62f9b931$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $62bbba4b62f9b931$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $62bbba4b62f9b931$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $e40c931179dab0a5$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $877235af7931ac6c$var$extendStatics = function extendStatics1(d, b) {
    $877235af7931ac6c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $877235af7931ac6c$var$extendStatics(d, b);
};
function $877235af7931ac6c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $877235af7931ac6c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $877235af7931ac6c$export$18ce0697a983be9b = function __assign1() {
    $877235af7931ac6c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $877235af7931ac6c$export$18ce0697a983be9b.apply(this, arguments);
};
function $877235af7931ac6c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $877235af7931ac6c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $877235af7931ac6c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $877235af7931ac6c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $877235af7931ac6c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $877235af7931ac6c$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $e40c931179dab0a5$export$5f0017c582d45a2d)(x)) === "symbol" ? x : "".concat(x);
}
function $877235af7931ac6c$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $e40c931179dab0a5$export$5f0017c582d45a2d)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $877235af7931ac6c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $877235af7931ac6c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $877235af7931ac6c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $877235af7931ac6c$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $877235af7931ac6c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $877235af7931ac6c$export$45d3717a4c69092e(o, m, p);
}
function $877235af7931ac6c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $877235af7931ac6c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $877235af7931ac6c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($877235af7931ac6c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $877235af7931ac6c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $877235af7931ac6c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $877235af7931ac6c$export$10c90e4f7922046c(v) {
    return this instanceof $877235af7931ac6c$export$10c90e4f7922046c ? (this.v = v, this) : new $877235af7931ac6c$export$10c90e4f7922046c(v);
}
function $877235af7931ac6c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $877235af7931ac6c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $877235af7931ac6c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $877235af7931ac6c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $877235af7931ac6c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $877235af7931ac6c$export$19a8beecd37a4c45 === "function" ? $877235af7931ac6c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $877235af7931ac6c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $877235af7931ac6c$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $877235af7931ac6c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $877235af7931ac6c$export$45d3717a4c69092e(result, mod, k);
    }
    $877235af7931ac6c$var$__setModuleDefault(result, mod);
    return result;
}
function $877235af7931ac6c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $877235af7931ac6c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $877235af7931ac6c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $877235af7931ac6c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $877235af7931ac6c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $877235af7931ac6c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $877235af7931ac6c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $877235af7931ac6c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $877235af7931ac6c$export$2e2bcd8739ae039 = {
    __extends: $877235af7931ac6c$export$a8ba968b8961cb8a,
    __assign: $877235af7931ac6c$export$18ce0697a983be9b,
    __rest: $877235af7931ac6c$export$3c9a16f847548506,
    __decorate: $877235af7931ac6c$export$29e00dfd3077644b,
    __param: $877235af7931ac6c$export$d5ad3fd78186038f,
    __metadata: $877235af7931ac6c$export$f1db080c865becb9,
    __awaiter: $877235af7931ac6c$export$1050f835b63b671e,
    __generator: $877235af7931ac6c$export$67ebef60e6f28a6,
    __createBinding: $877235af7931ac6c$export$45d3717a4c69092e,
    __exportStar: $877235af7931ac6c$export$f33643c0debef087,
    __values: $877235af7931ac6c$export$19a8beecd37a4c45,
    __read: $877235af7931ac6c$export$8d051b38c9118094,
    __spread: $877235af7931ac6c$export$afc72e2116322959,
    __spreadArrays: $877235af7931ac6c$export$6388937ca91ccae8,
    __spreadArray: $877235af7931ac6c$export$1216008129fb82ed,
    __await: $877235af7931ac6c$export$10c90e4f7922046c,
    __asyncGenerator: $877235af7931ac6c$export$e427f37a30a4de9b,
    __asyncDelegator: $877235af7931ac6c$export$bbd80228419bb833,
    __asyncValues: $877235af7931ac6c$export$e3b29a3d6162315f,
    __makeTemplateObject: $877235af7931ac6c$export$4fb47efe1390b86f,
    __importStar: $877235af7931ac6c$export$c21735bcef00d192,
    __importDefault: $877235af7931ac6c$export$da59b14a69baef04,
    __classPrivateFieldGet: $877235af7931ac6c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $877235af7931ac6c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $877235af7931ac6c$export$81fdc39f203e4e04,
    __addDisposableResource: $877235af7931ac6c$export$88ac25d8e944e405,
    __disposeResources: $877235af7931ac6c$export$8f076105dc360e92
};


/**
 * Módulo de notificações - ícone no topo, painel de avisos e notificação no navegador (push).
 * Consome api/notificacao (GET lista, PATCH marcar lida).
 * Eventos: renda passiva, subscrição, bonificação, dividendos/JCP, textos personalizados.
 */ (function() {
    var baseURL = window.location.origin;
    var urlNotificacoes = "".concat(baseURL, "/api/notificacao/");
    function formatarData(dataStr) {
        if (!dataStr) return "";
        var d = new Date(dataStr);
        return d.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    }
    function fetchNotificacoes() {
        return _fetchNotificacoes.apply(this, arguments);
    }
    function _fetchNotificacoes() {
        _fetchNotificacoes = (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
            var params, qs, url, response;
            var _arguments = arguments;
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                        qs = new URLSearchParams(params).toString();
                        url = qs ? "".concat(urlNotificacoes, "?").concat(qs) : urlNotificacoes;
                        return [
                            4,
                            fetch(url, {
                                credentials: "include",
                                headers: {
                                    "X-Requested-With": "XMLHttpRequest"
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.ok) throw new Error("Erro ao carregar notifica\xe7\xf5es");
                        return [
                            2,
                            response.json()
                        ];
                }
            });
        });
        return _fetchNotificacoes.apply(this, arguments);
    }
    function fetchNotificacoesPaginated() {
        return _fetchNotificacoesPaginated.apply(this, arguments);
    }
    function _fetchNotificacoesPaginated() {
        _fetchNotificacoesPaginated = /** Como fetchNotificacoes, mas em 404 (página fora do intervalo) retorna { results: [], next: null } em vez de lançar. */ (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
            var params, qs, url, response;
            var _arguments = arguments;
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                        qs = new URLSearchParams(params).toString();
                        url = qs ? "".concat(urlNotificacoes, "?").concat(qs) : urlNotificacoes;
                        return [
                            4,
                            fetch(url, {
                                credentials: "include",
                                headers: {
                                    "X-Requested-With": "XMLHttpRequest"
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.status === 404) return [
                            2,
                            {
                                results: [],
                                next: null,
                                previous: null,
                                count: 0,
                                total_pages: 0,
                                current_page: params.page || 1
                            }
                        ];
                        if (!response.ok) throw new Error("Erro ao carregar notifica\xe7\xf5es");
                        return [
                            2,
                            response.json()
                        ];
                }
            });
        });
        return _fetchNotificacoesPaginated.apply(this, arguments);
    }
    /**
	 * Retorna o filtro de carteira para notificações.
	 * Defina window.notificacoesCarteiraFilter = { carteira: 1, carteiras: [2, 3] } para filtrar.
	 * - carteira: id (número) de uma carteira específica → ?carteira=1
	 * - carteiras: ids (array ou string "1,2") para o campo M2M → ?carteiras=1,2
	 */ function getCarteiraFilter() {
        var f = window.notificacoesCarteiraFilter;
        if (!f || typeof f !== "object") return {};
        return {
            carteira: f.carteira,
            carteiras: f.carteiras
        };
    }
    var PAGE_SIZE = 50;
    function fetchNotificacoesList() {
        return _fetchNotificacoesList.apply(this, arguments);
    }
    function _fetchNotificacoesList() {
        _fetchNotificacoesList = /**
	 * Faz 2 requisições (uma com ?carteira=id, outra com ?carteiras=id1,id2), junta os resultados e remove duplicatas por id.
	 * Suporta paginação (page). Retorna { list, hasMore }.
	 * @param {Object} filters - { carteira, carteiras, lida, page }
	 */ (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
            var filters, carteira, carteiras, lida, _filters_page, page, hasCarteira, carteirasArr, hasCarteiras, baseParams, data, list, hasMore, promises, results, byId, hasMore1, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data1, list1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, n, merged;
            var _arguments = arguments;
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        filters = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                        carteira = filters.carteira, carteiras = filters.carteiras, lida = filters.lida, _filters_page = filters.page, page = _filters_page === void 0 ? 1 : _filters_page;
                        hasCarteira = carteira != null && carteira !== "";
                        carteirasArr = Array.isArray(carteiras) ? carteiras : typeof carteiras === "string" && carteiras.trim() ? carteiras.split(",").map(function(s) {
                            return s.trim();
                        }).filter(Boolean) : [];
                        hasCarteiras = carteirasArr.length > 0;
                        baseParams = {
                            page_size: PAGE_SIZE,
                            page: page
                        };
                        if (lida !== undefined && lida !== null) baseParams.lida = lida;
                        if (!(!hasCarteira && !hasCarteiras)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            fetchNotificacoesPaginated(baseParams)
                        ];
                    case 1:
                        data = _state.sent();
                        list = data.results || [];
                        hasMore = !!(data.next != null || data.total_pages != null && page < data.total_pages);
                        return [
                            2,
                            {
                                list: list,
                                hasMore: hasMore
                            }
                        ];
                    case 2:
                        // Quando temos ambos (ex.: mesmo id da carteira), usar só carteira para evitar 404 em carteiras
                        promises = [];
                        if (hasCarteira) promises.push(fetchNotificacoesPaginated((0, $62bbba4b62f9b931$export$4fa2f4023c9cbda5)((0, $621096155a85468e$export$581ff339ea0ba762)({}, baseParams), {
                            carteira: Number(carteira)
                        })));
                        if (hasCarteiras && !hasCarteira) promises.push(fetchNotificacoesPaginated((0, $62bbba4b62f9b931$export$4fa2f4023c9cbda5)((0, $621096155a85468e$export$581ff339ea0ba762)({}, baseParams), {
                            carteiras: carteirasArr.join(",")
                        })));
                        return [
                            4,
                            Promise.all(promises)
                        ];
                    case 3:
                        results = _state.sent();
                        byId = new Map();
                        hasMore1 = false;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = results[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                data1 = _step.value;
                                if (data1.next != null || data1.total_pages != null && page < data1.total_pages) hasMore1 = true;
                                list1 = data1.results || [];
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = list1[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        n = _step1.value;
                                        if (!byId.has(n.id)) byId.set(n.id, n);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        merged = Array.from(byId.values());
                        merged.sort(function(a, b) {
                            return new Date(b.data_criacao || 0) - new Date(a.data_criacao || 0);
                        });
                        return [
                            2,
                            {
                                list: merged,
                                hasMore: hasMore1
                            }
                        ];
                }
            });
        });
        return _fetchNotificacoesList.apply(this, arguments);
    }
    function marcarComoLida(id) {
        return _marcarComoLida.apply(this, arguments);
    }
    function _marcarComoLida() {
        _marcarComoLida = (0, $a1727a7253abe12d$export$7c398597f8905a1)(function(id) {
            var response;
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat(urlNotificacoes).concat(id, "/"), {
                                method: "PATCH",
                                credentials: "include",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-CSRFToken": getCsrfToken(),
                                    "X-Requested-With": "XMLHttpRequest"
                                },
                                body: JSON.stringify({
                                    lida: true
                                })
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response.ok
                        ];
                }
            });
        });
        return _marcarComoLida.apply(this, arguments);
    }
    function getCsrfToken() {
        var _document_querySelector;
        var name = "csrftoken";
        var token = (_document_querySelector = document.querySelector("[name=csrfmiddlewaretoken]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.value;
        if (token) return token;
        var cookies = document.cookie.split(";");
        for(var i = 0; i < cookies.length; i++){
            var c = cookies[i].trim();
            if (c.indexOf(name + "=") === 0) return c.substring(name.length + 1);
        }
        return "";
    }
    var stateNotificacoes = {
        list: [],
        hasMore: false,
        loadingMore: false,
        nextPage: 2
    };
    function renderPanel(container, list) {
        if (!container) return;
        // Usar sempre a lista do state para refletir carregamento paginado e marcações
        var listToRender = list != null ? list : stateNotificacoes.list;
        var listEl = container.querySelector("[js-notificacoes-lista]");
        var emptyEl = container.querySelector("[js-notificacoes-vazio]");
        var loadingEl = container.querySelector("[js-notificacoes-loading]");
        var loadingMoreEl = container.querySelector("[js-notificacoes-loading-more]");
        var badgeEl = container.querySelector("[js-notificacoes-badge]");
        var naoLidas = listToRender.filter(function(n) {
            return n.lida !== true && n.lida !== "true";
        });
        if (badgeEl) {
            badgeEl.textContent = naoLidas.length > 0 ? naoLidas.length > 99 ? "99+" : naoLidas.length : "";
            badgeEl.classList.toggle("hidden", naoLidas.length === 0);
        }
        if (loadingEl) loadingEl.classList.add("hidden");
        if (listEl) listEl.classList.remove("hidden");
        if (loadingMoreEl) loadingMoreEl.classList.toggle("hidden", !stateNotificacoes.loadingMore);
        // No dropdown só exibimos as não lidas; ao marcar como lida o item sai da lista
        var listarNoDropdown = naoLidas;
        if (emptyEl) emptyEl.classList.toggle("hidden", listarNoDropdown.length > 0);
        if (!listEl) return;
        listEl.innerHTML = listarNoDropdown.map(function(n) {
            return '\n			<li class="notificacao-item '.concat(n.lida ? "notificacao-lida" : "", '" data-id="').concat(n.id, '">\n				<div class="notificacao-item-header">\n					<strong class="notificacao-titulo">').concat(escapeHtml(n.titulo), '</strong>\n					<span class="notificacao-data">').concat(formatarData(n.data_criacao), '</span>\n				</div>\n				<p class="notificacao-descricao">').concat(escapeHtml(n.descricao), "</p>\n				").concat(!n.lida ? '<button type="button" class="notificacao-marcar-lida">Marcar como lida</button>' : "", "\n			</li>\n		");
        }).join("");
        listEl.querySelectorAll(".notificacao-marcar-lida").forEach(function(btn) {
            btn.addEventListener("click", function() {
                var _ref = (0, $a1727a7253abe12d$export$7c398597f8905a1)(function(e) {
                    var item, id, ok, idx;
                    return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                item = e.target.closest(".notificacao-item");
                                id = item && item.dataset.id;
                                if (!id) return [
                                    2
                                ];
                                return [
                                    4,
                                    marcarComoLida(id)
                                ];
                            case 1:
                                ok = _state.sent();
                                if (ok) {
                                    idx = stateNotificacoes.list.findIndex(function(n) {
                                        return String(n.id) === id;
                                    });
                                    if (idx >= 0) stateNotificacoes.list[idx].lida = true;
                                    document.querySelectorAll("[js-notificacoes-painel]").forEach(function(c) {
                                        return renderPanel(c, stateNotificacoes.list);
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(e) {
                    return _ref.apply(this, arguments);
                };
            }());
        });
    }
    function updateAllPanels(list) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (list != null) stateNotificacoes.list = list;
        if (opts.hasMore !== undefined) stateNotificacoes.hasMore = opts.hasMore;
        if (opts.loadingMore !== undefined) stateNotificacoes.loadingMore = opts.loadingMore;
        if (opts.nextPage !== undefined) stateNotificacoes.nextPage = opts.nextPage;
        document.querySelectorAll("[js-notificacoes-painel]").forEach(function(c) {
            return renderPanel(c, stateNotificacoes.list);
        });
    }
    function setLoadingAll(loading) {
        document.querySelectorAll("[js-notificacoes-loading]").forEach(function(el) {
            return el.classList.toggle("hidden", !loading);
        });
        document.querySelectorAll("[js-notificacoes-lista]").forEach(function(el) {
            return el.classList.toggle("hidden", loading);
        });
        document.querySelectorAll("[js-notificacoes-vazio]").forEach(function(el) {
            return el.classList.toggle("hidden", true);
        });
    }
    function setLoadingMore(loading) {
        document.querySelectorAll("[js-notificacoes-loading-more]").forEach(function(el) {
            return el.classList.toggle("hidden", !loading);
        });
    }
    function atualizarBadge() {
        return _atualizarBadge.apply(this, arguments);
    }
    function _atualizarBadge() {
        _atualizarBadge = (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
            var filter, hasFilter, count, params, data, data1, _;
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        filter = getCarteiraFilter();
                        hasFilter = filter.carteira != null && filter.carteira !== "" || Array.isArray(filter.carteiras) && filter.carteiras.length > 0;
                        count = 0;
                        if (!hasFilter) return [
                            3,
                            2
                        ];
                        // Uma requisição com page_size=1 só para pegar o total (data.count) da API
                        params = {
                            page_size: 1,
                            lida: "false"
                        };
                        if (filter.carteira != null && filter.carteira !== "") params.carteira = Number(filter.carteira);
                        else if (Array.isArray(filter.carteiras) && filter.carteiras.length > 0) params.carteiras = filter.carteiras.join(",");
                        return [
                            4,
                            fetchNotificacoesPaginated(params)
                        ];
                    case 1:
                        data = _state.sent();
                        count = data.count != null ? data.count : 0;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            fetchNotificacoes({
                                page_size: 1,
                                lida: "false"
                            })
                        ];
                    case 3:
                        data1 = _state.sent();
                        count = data1.count != null ? data1.count : 0;
                        _state.label = 4;
                    case 4:
                        document.querySelectorAll("[js-notificacoes-badge]").forEach(function(badgeEl) {
                            badgeEl.textContent = count > 0 ? count > 99 ? "99+" : count : "";
                            badgeEl.classList.toggle("hidden", count === 0);
                        });
                        return [
                            3,
                            6
                        ];
                    case 5:
                        _ = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _atualizarBadge.apply(this, arguments);
    }
    function criarPainelNotificacoes(container) {
        if (!container) return;
        var dropdown = container.closest("[js-dropdown-notificacao]");
        var SCROLL_THRESHOLD = 120;
        function carregarMais() {
            return _carregarMais.apply(this, arguments);
        }
        function _carregarMais() {
            _carregarMais = (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var filter, _ref, newList, hasMore, byId, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, n, id, merged, _;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (stateNotificacoes.loadingMore || !stateNotificacoes.hasMore) return [
                                2
                            ];
                            filter = getCarteiraFilter();
                            stateNotificacoes.loadingMore = true;
                            updateAllPanels(null, {
                                loadingMore: true
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetchNotificacoesList((0, $62bbba4b62f9b931$export$4fa2f4023c9cbda5)((0, $621096155a85468e$export$581ff339ea0ba762)({}, filter), {
                                    lida: "false",
                                    page: stateNotificacoes.nextPage
                                }))
                            ];
                        case 2:
                            _ref = _state.sent(), newList = _ref.list, hasMore = _ref.hasMore;
                            // Usar id como string no Map para evitar duplicata quando API retorna number vs string
                            byId = new Map(stateNotificacoes.list.map(function(n) {
                                return [
                                    String(n.id),
                                    n
                                ];
                            }));
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = newList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    n = _step.value;
                                    id = String(n.id);
                                    if (!byId.has(id)) byId.set(id, n);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            merged = Array.from(byId.values());
                            merged.sort(function(a, b) {
                                return new Date(b.data_criacao || 0) - new Date(a.data_criacao || 0);
                            });
                            stateNotificacoes.list = merged;
                            stateNotificacoes.hasMore = hasMore;
                            stateNotificacoes.nextPage += 1;
                            stateNotificacoes.loadingMore = false;
                            // Forçar re-render com a lista merged para o dropdown atualizar
                            updateAllPanels(merged, {
                                hasMore: hasMore,
                                nextPage: stateNotificacoes.nextPage,
                                loadingMore: false
                            });
                            return [
                                3,
                                4
                            ];
                        case 3:
                            _ = _state.sent();
                            stateNotificacoes.loadingMore = false;
                            updateAllPanels(null, {
                                loadingMore: false
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _carregarMais.apply(this, arguments);
        }
        function onScrollList(ev) {
            var el = ev.target;
            if (!el || !stateNotificacoes.hasMore || stateNotificacoes.loadingMore) return;
            var scrollTop = el.scrollTop, scrollHeight = el.scrollHeight, clientHeight = el.clientHeight;
            if (scrollTop + clientHeight >= scrollHeight - SCROLL_THRESHOLD) carregarMais();
        }
        function carregar() {
            return _carregar.apply(this, arguments);
        }
        function _carregar() {
            _carregar = (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
                var filter, _ref, list, hasMore, listEl, err;
                return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            stateNotificacoes.nextPage = 2;
                            setLoadingAll(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            filter = getCarteiraFilter();
                            return [
                                4,
                                fetchNotificacoesList((0, $62bbba4b62f9b931$export$4fa2f4023c9cbda5)((0, $621096155a85468e$export$581ff339ea0ba762)({}, filter), {
                                    lida: "false",
                                    page: 1
                                }))
                            ];
                        case 2:
                            _ref = _state.sent(), list = _ref.list, hasMore = _ref.hasMore;
                            stateNotificacoes.list = list;
                            stateNotificacoes.hasMore = hasMore;
                            updateAllPanels(list, {
                                hasMore: hasMore,
                                nextPage: 2
                            });
                            listEl = container.querySelector("[js-notificacoes-lista]");
                            if (listEl && !listEl.dataset.scrollAttached) {
                                listEl.dataset.scrollAttached = "1";
                                listEl.addEventListener("scroll", onScrollList);
                            }
                            return [
                                3,
                                5
                            ];
                        case 3:
                            err = _state.sent();
                            document.querySelectorAll("[js-notificacoes-vazio]").forEach(function(el) {
                                el.textContent = "N\xe3o foi poss\xedvel carregar as notifica\xe7\xf5es.";
                                el.classList.remove("hidden");
                            });
                            document.querySelectorAll("[js-notificacoes-lista]").forEach(function(el) {
                                return el.classList.add("hidden");
                            });
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setLoadingAll(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return _carregar.apply(this, arguments);
        }
        if (dropdown) {
            var opened = false;
            dropdown.addEventListener("click", function(e) {
                if (!opened && e.target.closest("[js-notificacoes-toggle]")) {
                    opened = true;
                    carregar();
                }
            });
        }
        window.notificacoesAtualizarBadge = atualizarBadge;
        window.notificacoesCarregarPainel = carregar;
    }
    function escapeHtml(text) {
        if (text == null) return "";
        var div = document.createElement("div");
        div.textContent = text;
        return div.innerHTML;
    }
    function init() {
        document.querySelectorAll("[js-notificacoes-painel]").forEach(criarPainelNotificacoes);
        // Garantir que o dropdown abra no mobile (touch): adicionar "active" ao clicar no toggle
        document.querySelectorAll("[js-notificacoes-toggle]").forEach(function(toggle) {
            var openDropdown = function openDropdown() {
                var dropdown = toggle.closest("[js-dropdown-notificacao]");
                if (dropdown) {
                    dropdown.classList.add("active");
                    if (typeof window.notificacoesCarregarPainel === "function") window.notificacoesCarregarPainel();
                }
            };
            toggle.addEventListener("touchstart", openDropdown, {
                passive: true
            });
            toggle.addEventListener("click", openDropdown);
        });
        document.querySelectorAll("[js-notificacoes-fechar]").forEach(function(btn) {
            btn.addEventListener("click", function(e) {
                e.stopPropagation();
                var dropdown = btn.closest("[js-dropdown-notificacao]");
                if (dropdown) dropdown.classList.remove("active");
            });
        });
        // Ao abrir o modal de notificações (mobile), carregar lista
        document.querySelectorAll("[data-xopen='modal_notificacoes']").forEach(function(el) {
            el.addEventListener("click", function() {
                if (typeof window.notificacoesCarregarPainel === "function") window.notificacoesCarregarPainel();
            });
        });
        // Badge já carrega ao entrar na página (número correto desde o início)
        atualizarBadge();
        window.notificacoesAtualizarBadge = atualizarBadge;
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
    else init();
    // Notificação no navegador (push local quando há novas não lidas)
    var ultimoCountNaoLidas = null;
    function verificarEPush() {
        return _verificarEPush.apply(this, arguments);
    }
    function _verificarEPush() {
        _verificarEPush = (0, $a1727a7253abe12d$export$7c398597f8905a1)(function() {
            var data, count, _;
            return (0, $877235af7931ac6c$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!("Notification" in window) || Notification.permission !== "granted") return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetchNotificacoes({
                                page_size: 1,
                                lida: "false"
                            })
                        ];
                    case 2:
                        data = _state.sent();
                        count = data.count != null ? data.count : 0;
                        if (ultimoCountNaoLidas !== null && count > ultimoCountNaoLidas && count > 0) new Notification("Investidor de Verdade", {
                            body: count === 1 ? "Voc\xea tem 1 nova notifica\xe7\xe3o." : "Voc\xea tem ".concat(count, " novas notifica\xe7\xf5es."),
                            icon: "/static/front_assets/assets/src/img/logo.svg"
                        });
                        ultimoCountNaoLidas = count;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _ = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _verificarEPush.apply(this, arguments);
    }
    function solicitarPermissaoPush() {
        if (!("Notification" in window)) return;
        if (Notification.permission === "default") Notification.requestPermission().then(function() {
            if (Notification.permission === "granted") verificarEPush();
        });
        else if (Notification.permission === "granted") verificarEPush();
    }
    // Atualizar badge ao ganhar foco (volta da aba)
    window.addEventListener("focus", function() {
        var fn = window.notificacoesAtualizarBadge;
        if (typeof fn === "function") fn();
        verificarEPush();
    });
    window.NotificacoesModule = {
        fetchNotificacoes: fetchNotificacoes,
        fetchNotificacoesList: fetchNotificacoesList,
        getCarteiraFilter: getCarteiraFilter,
        marcarComoLida: marcarComoLida,
        solicitarPermissaoPush: solicitarPermissaoPush,
        verificarEPush: verificarEPush
    };
})();


(0, $3d1ebc11d4258694$export$2e2bcd8739ae039)();
(0, $3f2dfe3d275d4551$export$2e2bcd8739ae039)();
(0, $c0eab5bc5351d202$export$2e2bcd8739ae039)();
(0, $96c884697ae6a3d3$export$2e2bcd8739ae039)();
(0, $2046ecdfab271433$export$2e2bcd8739ae039)(); // Faz as implementações relacionadas aos inlines
(0, $205e8b8d8015b418$export$2e2bcd8739ae039)(); // muda class ativa nos inputs
(0, $0e81e892d5a52a46$export$2e2bcd8739ae039)();
(0, $22a75a886b0b8dbc$export$2e2bcd8739ae039)(); //mostra elemento de acordo com parametro na url
(0, $f19d211b09d52e5e$export$2e2bcd8739ae039)();
(0, $e09c849cb9644edb$export$2e2bcd8739ae039)(); //inicia bibiloteca Choices.js
(0, $8ba429b0b9b3dac4$export$2e2bcd8739ae039)();
(0, $18bd69296407b2f6$export$2e2bcd8739ae039)();
(0, $ae9b8d77b8bd2975$export$2e2bcd8739ae039)();
(0, $69bc85ee0ce1602d$export$2e2bcd8739ae039)(); //adiona um filtro na url e recarrega
//table
(0, $63778ce2e408aa91$export$2e2bcd8739ae039)(); //show hide coluns
(0, $317043d73433f2bc$export$2e2bcd8739ae039)(); // ordenacao ao clicar na thead
(0, $587ba43941d5e4e6$export$2e2bcd8739ae039)(); //Busca da tabela basica
(0, $235375ae4e32064b$export$2e2bcd8739ae039)(); //quantidade de items vcisiveis na tabela
(0, $da1da581d5b7157f$export$2e2bcd8739ae039)(); //ordena por id maior ou menor
(0, $c897b5d91a827bfa$export$2e2bcd8739ae039)(); //coloca no window a funçao de criaro card do filepond
(0, $58e8d06c77f72924$export$2e2bcd8739ae039)();
(0, $7c1d9eb929b0fae3$export$2e2bcd8739ae039)(); //valida se os selects obrigatorios estao preenchidos
(0, $1d38e042de70a016$export$2e2bcd8739ae039)();
(0, $5a19cc8bf822ea54$export$2e2bcd8739ae039)();
(0, $c99f99fca54a91b4$export$2e2bcd8739ae039)();
(0, $100c9146e4611213$export$2e2bcd8739ae039)();
// const menu = multiLevelMenu(subMenuItens).init()
// window.menu = menu
// window.modalFiltrar = modalFiltrar
// console.log(modalFiltrar)
document.addEventListener("DOMContentLoaded", function() {
    return document.body.classList.add("DOMContentLoaded");
});

})();
//# sourceMappingURL=main.js.map
